// extracted by mini-css-extract-plugin
export default {"alert-group":"alert-group__1c3Lm"};